'use client';

import React, { FC, ReactNode, useState } from 'react';

export interface GenericAccordionProps {
  header: ReactNode;
  children: ReactNode;
  defaultOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
  className?: string;
  headerClassName?: string;
  transitionDuration?: number;
  maxHeight?: string;
  ariaLabel?: string;
  testId?: string;
}

export const GenericAccordion: FC<GenericAccordionProps> = ({
  header,
  children,
  defaultOpen = false,
  onToggle,
  className = '',
  headerClassName = '',
  transitionDuration = 300,
  maxHeight = '2000px',
  ariaLabel,
  testId,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleToggle = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    onToggle?.(newState);
  };

  const transitionStyle = {
    transitionDuration: `${transitionDuration}ms`,
  };

  const contentStyle = {
    ...transitionStyle,
    maxHeight: isOpen ? maxHeight : '0',
    opacity: isOpen ? 1 : 0,
  };

  return (
    <div className={className} data-testid={testId}>
      {/* Accordion Header/Button */}
      <button
        className={headerClassName}
        onClick={handleToggle}
        aria-expanded={isOpen}
        aria-label={ariaLabel}
        type="button"
      >
        {header}
      </button>

      {/* Accordion Content */}
      <div
        className="overflow-hidden transition-all ease-in-out"
        style={contentStyle}
      >
        {children}
      </div>
    </div>
  );
};

export default GenericAccordion;
